// extracted by mini-css-extract-plugin
export default {"main":"waa-z"};